export default __webpack_public_path__ + "static/media/logo192.0a8f4c90.png";